import { Component, OnInit, Inject, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import {  MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CommonPopup } from 'src/app/admin-dashboard/common-popup/common-popup';
import { ExcelService } from 'src/app/shared/excel';
import { ImportTableService } from 'src/app/services/import-table.service';
import { NotificationService } from 'src/app/shared/notification.service';
import { DialogDelete } from 'src/app/dialog-delete/dialog-delete.component';
import type { WorkBook } from 'xlsx';

@Component({
  selector: 'app-table-view-popup',
  templateUrl: './table-view-popup.component.html',
  styleUrls: ['./table-view-popup.component.css',
    '../../admin-dashboard/common-popup/common-popup.css']
})
export class TableViewPopup {
  keys = [];
  columnsToDisplay: string[];
  dataSource;
  rowActionButtons = ['image'];
  index = 0;
  @ViewChild('TABLE',{static:false}) table: ElementRef;
  constructor(public dialogRef: MatDialogRef<CommonPopup>,
    private importTableService: ImportTableService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data, private excelService: ExcelService) {
  }

  getKeys() {
    return this.columnsToDisplay
  }

  async export() {
    let result = await this.excelService.tableToJson(this.table.nativeElement);
    let string = JSON.stringify(result);
    let jsonData = JSON.parse(string);

    console.log(jsonData)
    let validation = await this.checkValidation(this.data.requiredColumn, jsonData);

    console.log(validation)
    if (validation['success']) {
      let response = await this.importTableService.uploadData(this.data.dbPath, this.data.requiredColumn, jsonData, this.data.groups || []);
      if (response) {
        console.log("response", response)
        this.dialogRef.close(response)
      }

    }
    else
      this.notificationService.showNotification("error", validation['message'])

    // 
  }

  checkValidation(requiredColumn, data) {

    let missing = []
    return new Promise((res, rej) => {

      for (let i = 0; i < requiredColumn.length; i++) {
        if (!(requiredColumn[i]['name'] in data[0])) {
          missing.push(requiredColumn[i]['name'])
        }
      }
      if (missing.length > 0)
        res({ success: false, message: missing + " fields are missing" });
      else
        res({ success: true, message: "Uploading..." });

    })

  }

  onBlur(element, columnSetting) {
    element[columnSetting] = event.target['innerText'];
    // console.log(element,event.target['innerText'])
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  openFile() {
    // event.preventDefault();

    let element: HTMLElement = document.getElementById('importfile') as HTMLElement;

    element.click();
  }

  delete(id) {
    // event.stopPropagation();
    const dialogRef = this.dialog.open(DialogDelete, {
      disableClose: true,
      width: '400px',
      data: {
        formData: {
          title: "DELETE",
          message: " Are you sure to remove column from table? "
        }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // if (this.columnsToDisplay.length) {
        let index = this.columnsToDisplay.indexOf(id)
        this.columnsToDisplay.splice(index, 1);
        // }
      }
    });

  }

  addColumn() {
    let value = 'newColumn' + this.index
    this.columnsToDisplay.push(value);
    this.index++;
  }

  async onFileChange(ev) {

    this.keys = [];
    this.columnsToDisplay = [];
    this.dataSource = null


    let workBook: WorkBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = async (event) => {
      const XLSX = await import('xlsx');
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      const dataString = JSON.stringify(jsonData);
      const dataJson = JSON.parse(dataString)

      const keys = Object.keys(dataJson)
      let combineArry = [];
      for (const key of keys) {
        combineArry.push(...dataJson[key])
      }

      this.dataSource = combineArry

      combineArry.forEach(obj => {
        this.keys.push(...Object.keys(obj))
      })
      this.columnsToDisplay = Array.from(new Set(this.keys));
    }
    reader.readAsBinaryString(file);
  }


  downloadTemplate() {
    console.log("Download")
    if (this.data.dummyTemplate)
      this.excelService.exportAsExcelFile(this.data.dummyTemplate, "dummyTemplate");
  }

  downloadCurrentTable() {
    this.excelService.exportFromTable(this.table.nativeElement, "download");
  }
}
